/**
 * The self-declared "filed by" name, remembered locally so it is typed once.
 *
 * NOT identity. `visitor_name`/`visitor_email` stay server-assembled from the
 * Clerk user and are the only trustworthy identity; this is a courtesy label,
 * always rendered with a "(self-declared)" qualifier on the ticket. It exists
 * because three reviewers share one demo login, so without it every ticket
 * reads as the same person.
 *
 * Deliberately NOT keyed by user id (unlike the onboarding hint): the whole
 * point is that it survives across shared demo logins on one reviewer's machine.
 */
const KEY = "fomo-fi:qa-filer";

/** Matches the backend's Feedback.filer_name column width. */
export const MAX_FILER_NAME = 80;

export function loadFilerName(): string {
  try {
    return (localStorage.getItem(KEY) ?? "").slice(0, MAX_FILER_NAME);
  } catch {
    // Private mode / storage disabled — the field still works, just isn't remembered.
    return "";
  }
}

export function saveFilerName(name: string): void {
  try {
    const trimmed = name.trim().slice(0, MAX_FILER_NAME);
    if (trimmed) localStorage.setItem(KEY, trimmed);
    else localStorage.removeItem(KEY);
  } catch {
    // Non-fatal: never let storage failure block a submission.
  }
}
